export default[
   {
      path: '/agent',
      component: () => import( '@/views/loud/agent/agent.vue'),
   },
   {
      path: '/agent/agentCopy',
      component: () => import( '@/views/loud/agent/agentCopy.vue'),
      meta: {keepAlive:true,title: '经销商列表',
         isTabsPage: true
      }
   },
   {
      path: '/agent/scoreShenPi',
      component: () => import( '@/views/loud/agent/agentScoreShenpi.vue'),
   },
   //经销商新增、审批、查看页面
   {
      path: '/agentDetail',
      component: () => import( '@/views/loud/agent/agentDetail.vue'),
      meta: {
         title: '经销商详情',
         isTabsPage: false,
         keepAlive:false
      }
   },

   {
      path: '/agentApprove',
      component: () => import( '@/views/loud/agent/agentApprove.vue'),
   },
   {
      path: '/agentUpdateShangWei',
      component: () => import( '@/views/loud/agent/agentUpdateShangWei.vue'),
   },
    //新经销商修改审批页面
   {
      path: '/agentQyApprove',
      component: () => import( '@/views/loud/agent/agentQyApprove.vue'),
   },
    //经销商注册徐喆审批页面
   {
      path: '/agentXZApprove',
      component: () => import( '@/views/loud/agent/agentXZApprove.vue'),
   },
   //新经销商修改审批页面 杨宝栋
   {
      path: '/agentAuthApprove',
      component: () => import( '@/views/loud/agent/agentAuthApprove.vue'),
   },
   {
      path: '/agentFenxiaoApprove',
      component: () => import( '@/views/loud/agent/agentFenxiaoApprove.vue'),
   },
   //经销商手动维护页面
   {
      path: '/agentDetailMaintain',
      component: () => import( '@/views/loud/agent/agentDetailMaintain.vue'),
      meta: {
         title: '经销商维护',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/agentDetailEdit',
      component: () => import( '@/views/loud/agent/agentDetailEdit.vue'),
   },

   //经销商新增、审批、查看页面
   {
      path: '/agentThaw',
      component: () => import( '@/views/loud/agent/agentThaw.vue'),
      meta: {
         title: '经销商冻结',
         isTabsPage: false,
         keepAlive:false
      }
   },

   {
      path: '/agentThawLq',
      component: () => import( '@/views/loud/agent/agentThawLq.vue'),
      meta: {
         title: '经销商履约解冻',
         isTabsPage: false,
         keepAlive:false
      }
   },
   {
      path: '/partnerHighSeas',
      component: () => import( '@/views/loud/partnerhighseas/partnerhighseas.vue'),
      meta: {
         title: '合伙人公海',
         isTabsPage: false,
         keepAlive:false
      }
   },
   //经销商新增、审批、查看页面
   {
      path: '/agentFenxiaoCopy',
      component: () => import( '@/views/loud/agent/agentFenxiaoCopy.vue'),
      meta: {
         title: '分销商1.0列表',
         isTabsPage: true,
         keepAlive:true
      }
   },
    //平台商模式配置
   {
      path: '/agent/platformConfig',
      component:()=>import('@/views/loud/platformConfig/bscHhptAgentType.vue'),
      meta: {
         title: '平台商模式配置',
         isTabsPage: true,
         keepAlive:true
      }
   },

   // 经销商/代理商等级变更历史报表
   {
      path: '/agent/agentLevelChangeHistory',
      component: () => import('@/views/loud/agent/agentLevelChangeHistory.vue'),
      meta: {
         title: '价格层级变动记录',
         isTabsPage: true,
         keepAlive: false
      }
   },
    //产业目标导入详情
   {
      path: '/agent/industryTargetTabs',
      component: () => import( '@/views/loud/agent/industryTargetImport/industryTargetTabs.vue'),
      meta: {
         title: '产业目标导入详情',
         isTabsPage: true,
      }
   },
]
